import { useAddToCartStatus } from '@src/domains/products/hooks/useAddToCartStatus';

const BookingStatus = () => {
  useAddToCartStatus();

  return null;
};

export default BookingStatus;
